import React from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import CurrentDateTime from "./CurrentDateTime";

export default function NotifInfo() {

  return (
    <Container>
      <Top>
        <Img src="/Assets/Images/Date.png" />
        <Date>{CurrentDateTime()}</Date>
      </Top>
      <Bottom>
        <ButtonEmail>
          <Icon src="/Assets/Images/Email.svg" />
        </ButtonEmail>
        <Button>
          <Icon src="/Assets/Images/Notif.svg" />
        </Button>
        <Button>
          <Icon src="/Assets/Images/Profile.svg" />
        </Button>
      </Bottom>
    </Container>
  );
}

const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${Theme.colorBackgroundBox};
  width: 15.7%;
  height: 172px;
  margin: 0 15px 0 0;
  float: left;
  box-sizing: border-box;
  border-radius: ${Theme.borderRadius};
`;

const Img = styled.img`
  width: 20px;
  height: 20px;
  padding: 10px;
`;

const Icon = styled.img`
  width: 30px;
  height: 30px;
`;

const Date = styled.p`
  padding: 10px;
  margin: -3px;
  color: ${Theme.colorFontBlack};
  font-style: normal;
  font-weight: 400;
  font-size: 1.1rem;
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  padding: 15px;
  flex-direction: row;
  justify-content: center;
`;

const Bottom = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-evenly;
`;

const Button = styled.button`
  background-color: ${Theme.colorIconButton};
  width: 50px;
  height: 50px;
  border: none;
  border-radius: ${Theme.borderRadius};
  margin: 5px;

  &:hover {
    background-color: ${Theme.colorBackgroundBoxHover};
    cursor: pointer;
  }
`;

const ButtonEmail = styled.button`
  background-color: ${Theme.colorIconButton};
  width: 50px;
  height: 50px;
  border: none;
  border-radius: ${Theme.borderRadius};
  margin: 5px;
  position: relative;

  &:hover {
    background-color: ${Theme.colorBackgroundBoxHover};
    cursor: pointer;
  }

  &::before {
    content: "1";
    position: absolute;
    background-color: #ef4444;
    width: 16px;
    height: 16px;
    bottom: -5px;
    right: -5px;
    border-radius: 50%;
    padding: 2px;
    color: ${Theme.colorFontWhite};
  }
`;
